module.exports = __webpack_public_path__ + "img/pickFour.324139a2.png";